import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import moment from 'moment';
import Lottie from 'lottie-react';

// Model //
import FetchModule from '../../../../Share/Network/FetchModule';
// Model //

// Component //
import RefundReasonInput from '../../../../../Component/MemberComponent/MemberDetail/NewRefundReasonInput';
import RefundPriceInput from '../../../../../Component/MemberComponent/MemberDetail/RefundPriceInput';
import CalenderInput from '../../../../../Component/LockerComponent/LockerCalenderInput';
// Component //

// Animation //
import LoadingAnimation from '../../../../../Animation/LoadingAnimation.json';
// Animation //

// Image //
import RefundIcon from '../../../../../image/RefundIcon.png';
// Image //

import { useLanguage } from '../../../../../Context/LanguageContext';

export default function LockerRefundModal(props) {
  const { memberName, rendering, exitClick, refundData } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [isCompleteSettlement, setIsCompleteSettlement] = useState(false);
  const [refundCardPrice, setRefundCardPrice] = useState(0);
  const [refundCashPrice, setRefundCashPrice] = useState(0);
  const [approvalDate, setApprovalDate] = useState(moment());
  const [reason, setReason] = useState('');

  const [isViewSelectModal, setIsViewSelectModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(t('memberDetail.lockerRefundModal.refundInProgress'));

  // 센터 환불인지 링크 환불인지 여부
  const [isCenterRefund, setIsCenterRefund] = useState(true);


  // 이전 환불 신청이 있는지 확인 및 세팅 //
  useEffect(() => {
    if (refundData.merchantUid.split('-')[2] !== '3') setIsCenterRefund(false);
    else setIsCenterRefund(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('sales/refund/state/' + refundData.merchantUid, 'GET');
        if (responseData.status === 200) {
          setIsCompleteSettlement(responseData.data.completeSettlement);
          setRefundCardPrice(responseData.data.cardPrice);
          setRefundCashPrice(responseData.data.cashPrice);
          setApprovalDate(moment(responseData.data.approvalDate));
          setReason(responseData.data.reason);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, refundData])

  // 로딩 텍스트 변경 //
  useEffect(() => {
    if (!isLoading) return;

    setTimeout(() => {
      if (loadingText === t('memberDetail.lockerRefundModal.refundInProgress')) setLoadingText(t('memberDetail.lockerRefundModal.refundInProgress') + '.');
      else if (loadingText === t('memberDetail.lockerRefundModal.refundInProgress') + '.') setLoadingText(t('memberDetail.lockerRefundModal.refundInProgress') + '..');
      else if (loadingText === t('memberDetail.lockerRefundModal.refundInProgress') + '..') setLoadingText(t('memberDetail.lockerRefundModal.refundInProgress') + '...');
      else if (loadingText === t('memberDetail.lockerRefundModal.refundInProgress') + '...') setLoadingText(t('memberDetail.lockerRefundModal.refundInProgress'));
    }, 800);
  }, [isLoading, loadingText])

  // 환불버튼 클릭시 //
  function onClickRefund() {

    if (!isCenterRefund) {
      if (parseInt(refundCardPrice) + parseInt(refundCashPrice) === 0) {
        alert(t('memberDetail.refundModal.alertEnterRefundAmount'));
        return;
      }

      // 정산일 이후 결제된 내역인경우 카드 취소 //
      if (!isCompleteSettlement) {
        let requestData = {
          merchantUid: refundData.merchantUid,
          cardPrice: refundCardPrice,
          cashPrice: refundCashPrice,
          reason: reason,
        }

        setIsLoading(true);

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/refund/linkpay', 'POST', requestData);

            if (responseData.status === 200) {
              setIsLoading(false);
              rendering();
              exitClick();
            }
            else if (responseData.status === 201) {
              alert(t('memberDetail.refundModal.alertInvalidRequest'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 202) {
              alert(t('memberDetail.refundModal.alertNotCompletedPayment'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 203) {
              alert(t('memberDetail.refundModal.alertNotLinkpayPayment'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 204) {
              alert(t('memberDetail.refundModal.alertPaymentDataNotFound'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 205) {
              alert(t('memberDetail.refundModal.alertAlreadyRefunded'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 206) {
              alert(t('memberDetail.refundModal.alertRefundExceeded'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 401) history.push('/');
            else {
              alert(responseData.error);
              setIsLoading(false);
              return;
            }
          }
        )();
      }
      // 정산일 이후의 경우 환불내역 생성전 안내문구 띄우기 //
      else {
        setIsViewSelectModal(true);
      }
    }
    else {
      if (parseInt(refundCardPrice) + parseInt(refundCashPrice) === 0) {
        alert(t('memberDetail.refundModal.alertEnterRefundAmount'));
        return;
      }

      let requestData = {
        merchantUid: refundData.merchantUid,
        cardPrice: refundCardPrice,
        cashPrice: refundCashPrice,
        reason: reason,
        approvalDate: approvalDate.format('YYYY-MM-DDTHH:mm:ss')
      }

      setIsLoading(true);

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/refund/center', 'POST', requestData);

          if (responseData.status === 200) {
            rendering();
            exitClick();
            setIsLoading(false);
          }
          else if (responseData.status === 204) {
            alert(t('memberDetail.refundModal.alertRefundExceeded'));
            setIsLoading(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  // 정산일 이전 데이터 확인모달에서 환불버튼 클릭시 //
  function onClickRefundOnCheckModal() {
    let requestData = {
      merchantUid: refundData.merchantUid,
      cardPrice: refundCardPrice,
      cashPrice: refundCashPrice,
      reason: reason,
    }
    setIsLoading(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('sales/refund/linkpay', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          rendering();
          exitClick();
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.refundModal.alertInvalidRequest'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.refundModal.alertNotCompletedPayment'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 203) {
          alert(t('memberDetail.refundModal.alertNotLinkpayPayment'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert(t('memberDetail.refundModal.alertPaymentDataNotFound'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 205) {
          alert(t('memberDetail.refundModal.alertAlreadyRefunded'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 206) {
          alert(t('memberDetail.refundModal.alertRefundExceeded'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  function onClickApprovalDate() {
  }

  function onChangeApprovalDate(data) {
    if (!isCenterRefund) {
      alert(t('memberDetail.refundModal.alertLinkpayDateFixed'));
      return;
    }

    setApprovalDate(data);
  }


  return (
    <TotalModalWrapper>
      {
        isLoading ?
          <ViewWrapper>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
            <LoadingTextWrapper>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={16} color='#595959' cursor='default'>{loadingText}</Text>
            </LoadingTextWrapper>
          </ViewWrapper>
          :
          <ModalTotalWrapper>
            {
              isViewSelectModal ?
                <SelectModalView>
                  <RedTrashBoxWrapper>
                    <EmptyButtonWrapper />
                    <RedTrashBox>
                      <RefundImage src={RefundIcon} />
                    </RedTrashBox>
                    <EmptyButtonWrapper />
                  </RedTrashBoxWrapper>
                  <TotalWrapper>
                    <Title>{t('memberDetail.refundModal.linkopayRefundTitle')}</Title>
                    <SelectTextWrapper>
                      <Explanation>{t('memberDetail.lockerRefundModal.alreadySettledLocker')}</Explanation>
                      <Explanation>{t('memberDetail.lockerRefundModal.cardCancelNotProceed')}</Explanation>
                    </SelectTextWrapper>
                  </TotalWrapper>
                  <SelectButtonWrapper>
                    <NoButton onClick={() => setIsViewSelectModal(false)}>{t('memberDetail.modalClose')}</NoButton>
                    <YesButton onClick={onClickRefundOnCheckModal}>{t('memberDetail.refundModal.btnRefundAction')}</YesButton>
                  </SelectButtonWrapper>
                </SelectModalView>
                :
                <ModalViewWrapper isCenterRefund={isCenterRefund}>
                  {
                    isCenterRefund ?
                      <ModalView>
                        <TotalView>
                          <TitleWrapper>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{t('memberDetail.lockerRefundModal.lockerRefundTitleWithName').replace('{memberName}', memberName)}</Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>{t('memberDetail.refundModal.refundIrreversibleDesc')}</Text>
                          </TitleWrapper>
                          <TotalMembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.lockerRefundModal.lockerName')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{refundData.membershipName}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{moment(refundData.approvalDate).format('YYYY.MM.DD')}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <PaymentInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.paymentAmount')}</Text>
                              </InfoTextWrapper>
                              <PaymentOptionsWrapper>
                                {
                                  refundData.selectedPaymentOptions && refundData.selectedPaymentOptions.length > 0 ?
                                    <PaymentDivisionBoxWrapper>
                                      <PaymentDivisionBox isCard={refundData.selectedPaymentOptions.length === 1 && (refundData.selectedPaymentOptions[0].name === '카드' || refundData.selectedPaymentOptions[0].name === '링코페이')}>
                                        <PaymentDivisionBoxTextWrapper>
                                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>
                                            {refundData.selectedPaymentOptions.length === 1 ? refundData.selectedPaymentOptions[0].name : t('memberDetail.payCombined')}
                                          </Text>
                                        </PaymentDivisionBoxTextWrapper>
                                      </PaymentDivisionBox>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{(refundData.totalPrice !== undefined ? refundData.totalPrice : refundData.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                    </PaymentDivisionBoxWrapper>
                                    :
                                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.payNone')}</Text>
                                }
                              </PaymentOptionsWrapper>
                              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                            </PaymentInfoWrapper>
                          </TotalMembershipInfoWrapper>
                          <TotalRefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundDate')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={220}>
                                <CalenderInput width={194} value={approvalDate} setValue={onChangeApprovalDate} className='' clickFn={onClickApprovalDate} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundAmount')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                              </InfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.card')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={220}>
                                <RefundPriceInput division='카드' value={refundCardPrice} setValue={setRefundCardPrice} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.cash')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={220}>
                                <RefundPriceInput division='현금' value={refundCashPrice} setValue={setRefundCashPrice} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                          </TotalRefundInfoWrapper>
                          <ReasonInfoWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundReason')}</Text>
                            <RefundReasonInput value={reason} setValue={setReason} placeholder={t('memberDetail.refundModal.refundReasonPlaceholder')} />
                          </ReasonInfoWrapper>
                          <CenterTextWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959'>{t('memberDetail.refundModal.totalPrefix')}</Text>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF3131' style={{ marginLeft: `4px` }}>{(parseInt(refundCashPrice) + parseInt(refundCardPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{t('memberDetail.refundModal.wonSuffix')}</Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959'>{t('memberDetail.refundModal.willBeRefunded')}</Text>
                          </CenterTextWrapper>
                          <ButtonWrapper>
                            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
                            <SaveButton onClick={onClickRefund}>{t('memberDetail.refundModal.btnDoRefund')}</SaveButton>
                          </ButtonWrapper>
                        </TotalView>
                      </ModalView>
                      :
                      <ModalView>
                        <LinkoPayTitleWrapper>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>{t('memberDetail.lockerRefundModal.lockerRefundTitleWithName').replace('{memberName}', memberName)}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>{t('memberDetail.refundModal.refundIrreversibleDesc')}</Text>
                        </LinkoPayTitleWrapper>
                        <TotalView>
                          <TotalMembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.lockerRefundModal.lockerName')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{refundData.membershipName}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{moment(refundData.approvalDate).format('YYYY.MM.DD')}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <PaymentInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.paymentAmount')}</Text>
                              </InfoTextWrapper>
                              <PaymentOptionsWrapper>
                                {
                                  refundData.selectedPaymentOptions && refundData.selectedPaymentOptions.length > 0 ?
                                    <PaymentDivisionBoxWrapper>
                                      <PaymentDivisionBox isCard={refundData.selectedPaymentOptions.length === 1 && (refundData.selectedPaymentOptions[0].name === '카드' || refundData.selectedPaymentOptions[0].name === '링코페이')}>
                                        <PaymentDivisionBoxTextWrapper>
                                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>
                                            {refundData.selectedPaymentOptions.length === 1 ? refundData.selectedPaymentOptions[0].name : t('memberDetail.payCombined')}
                                          </Text>
                                        </PaymentDivisionBoxTextWrapper>
                                      </PaymentDivisionBox>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{(refundData.totalPrice !== undefined ? refundData.totalPrice : refundData.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                    </PaymentDivisionBoxWrapper>
                                    :
                                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.payNone')}</Text>
                                }
                              </PaymentOptionsWrapper>
                              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                            </PaymentInfoWrapper>
                          </TotalMembershipInfoWrapper>
                          <TotalRefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundDate')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={220}>
                                <CalenderInput width={194} value={approvalDate} setValue={onChangeApprovalDate} className='' clickFn={onClickApprovalDate} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundAmount')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                              </InfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.card')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={220}>
                                <RefundPriceInput division='카드' value={refundCardPrice} setValue={setRefundCardPrice} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                          </TotalRefundInfoWrapper>
                          <ReasonInfoWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{t('memberDetail.refundModal.refundReason')}</Text>
                            <RefundReasonInput value={reason} setValue={setReason} placeholder={t('memberDetail.refundModal.refundReasonPlaceholder')} />
                          </ReasonInfoWrapper>
                          <CenterTextWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959'>{t('memberDetail.refundModal.totalPrefix')}</Text>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FF3131' style={{ marginLeft: `4px` }}>{(parseInt(refundCashPrice) + parseInt(refundCardPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{t('memberDetail.refundModal.wonSuffix')}</Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959'>{t('memberDetail.refundModal.willBeRefunded')}</Text>
                          </CenterTextWrapper>
                          <ButtonWrapper>
                            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
                            <SaveButton onClick={onClickRefund}>{t('memberDetail.refundModal.btnDoRefund')}</SaveButton>
                          </ButtonWrapper>
                        </TotalView>
                      </ModalView>
                  }
                </ModalViewWrapper>
            }
          </ModalTotalWrapper>
      }
    </TotalModalWrapper>
  )
}


const ModalTotalWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;
`;

const ModalViewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding-bottom: 20px;

  width: 380px;
  height: ${props => props.isCenterRefund ? `580px` : `540px`};

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 340px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
`;

const LinkoPayTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 20px;

  width: calc(100% - 40px);

  border-radius: 10px 10px 0px 0px;
  background-color: #6DD49E;
`;

const TotalMembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 20px;
  margin-top: 36px;

  width: 100%;

  gap: 20px;

  border-bottom: 1px solid #B2B2B2;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 21px;

  gap: 20px;

  overflow: hidden;
`;

const PaymentDivisionBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const PaymentDivisionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0px 5px;

  max-width: 100px;
  max-height: 20px;

  border-radius: 5px;

  background-color: ${props => props.isCard ? '#6DD49E' : '#FF8B48'};
`;


const PaymentDivisionBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;


const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const PaymentOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 160px;

  gap: 8px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TotalRefundInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 14px;

  width: 100%;

  gap: 10px;
`;

const RefundInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;


const RefundInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 32px;

  gap: 20px;

  overflow: hidden;
`;

const ReasonInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 30px;

  width: 100%;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #5BD98A;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const CenterTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  margin-top: 13px;
`;

const SelectModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;
`;

const SelectTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 8px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const RefundImage = styled.img`
  width: 60px;
  height: 60px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const SelectButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const NoButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #CFCFCF;

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
`;

const YesButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: #CFCFCF;

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF3131;
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 40px;

  width: 180px;
  height: 240px;

  overflow: hidden;

  border-radius: 8px;
  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const LoadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 140px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
